import { FormEvent, useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { confirmEmailVerification, setVerifiedPassword } from '../../auth/memberApi';
import './auth.css';

const VerifyEmail = () => {
  const navigate = useNavigate();
  const [credentials] = useState(() => new URLSearchParams(window.location.hash.slice(1)));
  const email = credentials.get('email') || '';
  const token = credentials.get('token') || '';
  const started = useRef(false);
  const [verified, setVerified] = useState(false);
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [busy, setBusy] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    if (!email || !token) {
      setError('This verification link is incomplete. Return to login to request a new link.');
      setBusy(false);
      return;
    }
    confirmEmailVerification(email, token)
      .then(() => setVerified(true))
      .catch((err) => setError(err instanceof Error ? err.message : 'Unable to verify your email.'))
      .finally(() => setBusy(false));
  }, [email, token]);

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setError('');
    if (password !== confirmation) {
      setError('Passwords must match.');
      return;
    }
    setBusy(true);
    try {
      await setVerifiedPassword(email, token, password);
      navigate('/login', { replace: true, state: { message: 'Your email is verified and your password is set. You can now log in.' } });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Unable to set your password.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="auth-shell">
      <div className="auth-hero">
        <p>Member access</p>
        <h1>{verified ? 'Set your password.' : 'Verify your email.'}</h1>
        <span>{verified ? 'Your email is verified. Create your password to finish setting up your account.' : 'Verifying your Hogcloud email address.'}</span>
      </div>
      <div className="auth-card">
        <form className="auth-form" onSubmit={submit}>
          {error && <p className="auth-message error" role="alert">{error}</p>}
          {busy && <p role="status">Please wait...</p>}
          {verified && <>
            <p>{email}</p>
            <div className="auth-field">
              <label htmlFor="verified-password">New password</label>
              <input id="verified-password" type="password" autoComplete="new-password" minLength={12} required value={password} onChange={(event) => setPassword(event.target.value)} />
              <p className="auth-help">At least 12 characters with uppercase, lowercase, a number, and a symbol.</p>
            </div>
            <div className="auth-field">
              <label htmlFor="verified-confirmation">Confirm password</label>
              <input id="verified-confirmation" type="password" autoComplete="new-password" minLength={12} required value={confirmation} onChange={(event) => setConfirmation(event.target.value)} />
            </div>
            <button className="auth-submit" type="submit" disabled={busy}>Set password</button>
          </>}
          <p className="auth-switch"><Link to="/login">Return to login</Link></p>
        </form>
      </div>
    </section>
  );
};

export default VerifyEmail;
